<div class="button-align-right">
  <button #viewBtn mat-raised-button color="primary" (click)="view()" style= "background-color: #2575fc; color: white;"
     >{{'REPORT_ACTION.VIEW' | translate}} </button>
  <button #authoriseBtn mat-raised-button color="accent" (click)="downloadAsExcel()" style= "background-color: #2575fc; color: white;"
      >{{'REPORT_ACTION.DOWNLOAD_AS_EXCEL' | translate}} </button>
  <button #saveBtn mat-raised-button color="accent" (click)="downloadAsPdf()" style= "background-color: #2575fc; color: white;"
      >{{'REPORT_ACTION.DOWNLOAD_AS_PDF' | translate}} </button>
</div>
<div>
  <div id="reportMessage"></div>
  <div id="reportprintMessage"></div>
  <iframe id="reportResult" src="javascript:void(0);" style="width:100%; height:100vh; display: none;"></iframe>
</div>
